import { axios } from "@/libraries/axios";
import type { CreateMessageResponse, GetHemiReponse } from "@/types";
import type { GenericAbortSignal } from "axios";

class HemiService {
	async send(payload: Record<"uid" | "text" | "channel_name", string>) {
		try {
			const res = await axios.post("/api/v1/hemi", {
				message: {
					uid: payload.uid,
					text: payload.text,
				},
			});
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}
	async get() {
		try {
			const res = await axios.get<GetHemiReponse>("/api/v1/hemi");
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}
	async response(uid: string, signal: GenericAbortSignal) {
		try {
			const res = await axios.get<CreateMessageResponse>(
				`/api/v1/messages/${uid}/responses`,
				{
					signal,
				},
			);
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}
}

export const hemiService = Object.freeze(new HemiService());
